"use client";

import { c as _c } from "react/compiler-runtime";
import { Box } from "./ui/box";
import { Heading } from "./ui/heading";
import { Button } from "./ui/button";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { LoadMore } from "./common/load-more";
import { CourseCard } from "./common/course-card";
import { skipToken, useSuspenseQuery } from "@apollo/client/react";
import { CATEGORIZED_COURSES_QUERY } from "@/graphql/queries/categorized-courses";
import { useParams } from "next/navigation";
import { useMemo } from "react";
interface CategorizedCoursesContentProps {
  data: CategorizedCoursesInterface[];
  selectedCategory: string | null;
}
export const CategorizedCoursesContent = t0 => {
  const $ = _c(16);
  const {
    data: t1,
    selectedCategory
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const data = t2;
  const {
    country
  } = useParams();
  let t3;
  if ($[2] !== country) {
    t3 = country ? skipToken : {};
    $[2] = country;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: clientData
  } = useSuspenseQuery(CATEGORIZED_COURSES_QUERY, t3);
  clientData?.categoriesCourses;
  let t4;
  if (!country) {
    let t5;
    if ($[4] !== clientData?.categoriesCourses) {
      t5 = clientData?.categoriesCourses ?? [];
      $[4] = clientData?.categoriesCourses;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    t4 = t5;
  } else {
    t4 = data;
  }
  const categories = t4;
  let t5;
  if ($[6] !== categories || $[7] !== country || $[8] !== selectedCategory) {
    let t6;
    if ($[10] !== selectedCategory) {
      t6 = item => item.id == selectedCategory || selectedCategory == null;
      $[10] = selectedCategory;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== country) {
      t7 = cat => <Box key={cat.id} className="mt-6 mb-15"><Box className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"><Heading as="h4" render={<div />}>{`${cat.name} (${cat.totalCourse})`}</Heading><Button variant="outline" className="rounded-full" nativeButton={false} render={<Link href={country ? `/${country}/topic/${cat.slug}` : `/topic/${cat.slug}`} />}>View all courses <ArrowRight size={16} /></Button></Box><LoadMore wrapper={<div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" />} noOverflow={true} items={cat?.courses || []} initialVisibleItems={3} overlayHidden={true} renderItems={_temp} /></Box>;
      $[12] = country;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    t5 = categories.filter(t6).map(t7);
    $[6] = categories;
    $[7] = country;
    $[8] = selectedCategory;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <div>{t5}</div>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
function _temp(item_0, index) {
  return <div key={`${item_0.slug}-${index}`}><CourseCard serviceId={item_0.id} name={item_0.name} image={item_0.service_image} totalEnroll={item_0.numberOfLearners} duration={item_0.serviceTrainingDays} slug={item_0.slug} accreditation_name={item_0.accreditation_name} icon={item_0.serviceIcon} modeOfTraining={item_0.mode_of_training || "Live Classroom / Classroom"} sellingPriceNumber={item_0.price} currency={item_0.currency} serviceFlags={item_0.serviceFlags} isGenericPageOnly={item_0.isGenericPageOnly} /></div>;
}